"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _cache = _interopRequireDefault(require("@deosite/lib/cache"));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2["default"])(t); if (r) { var s = (0, _getPrototypeOf2["default"])(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2["default"])(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var isServer = typeof window === "undefined";
var __NEXT_CACHE__ = "__NEXT_CACHE__";
function getOrCreateCache() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Always make a new cache if server, otherwise state is shared between requests
  if (isServer) {
    return new _cache["default"](initialState);
  }
  if (!window[__NEXT_CACHE__]) {
    window[__NEXT_CACHE__] = new _cache["default"](initialState);
  }
  return window[__NEXT_CACHE__];
}
var withCache = function withCache(App) {
  return /*#__PURE__*/function (_React$Component) {
    (0, _inherits2["default"])(AppWithCache, _React$Component);
    var _super = _createSuper(AppWithCache);
    function AppWithCache(props) {
      var _this;
      (0, _classCallCheck2["default"])(this, AppWithCache);
      _this = _super.call(this, props);
      _this.cache = getOrCreateCache(props.initialCacheState);
      return _this;
    }
    (0, _createClass2["default"])(AppWithCache, [{
      key: "render",
      value: function render() {
        return __jsx(App, (0, _extends2["default"])({}, this.props, {
          cache: this.cache
        }));
      }
    }], [{
      key: "getInitialProps",
      value: function () {
        var _getInitialProps = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(appContext) {
          var cache, appProps;
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // Get or Create the store with `undefined` as initialState
                  // This allows you to set a custom default initialState
                  cache = getOrCreateCache(); // Provide the store to getInitialProps of pages
                  appContext.ctx.cache = cache;
                  appProps = {};
                  if (!(typeof App.getInitialProps === "function")) {
                    _context.next = 7;
                    break;
                  }
                  _context.next = 6;
                  return App.getInitialProps(appContext);
                case 6:
                  appProps = _context.sent;
                case 7:
                  return _context.abrupt("return", _objectSpread(_objectSpread({}, appProps), {}, {
                    initialCacheState: cache.extract()
                  }));
                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        function getInitialProps(_x) {
          return _getInitialProps.apply(this, arguments);
        }
        return getInitialProps;
      }()
    }]);
    return AppWithCache;
  }(_react["default"].Component);
};
var _default = withCache;
exports["default"] = _default;